//main.js
import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import { createPinia } from 'pinia'
// import { useHomeStore } from '@/store/homeStore'
// import { useProductsStore } from '@/store/productsStore'
import 'sweetalert2/dist/sweetalert2.min.css'; // 引入樣式
import VueLazyload from 'vue-lazyload'
import ElementPlus from 'element-plus'
import zhTw from 'element-plus/dist/locale/zh-tw.mjs'
import 'element-plus/dist/index.css'
/* import the fontawesome core */
import { library } from '@fortawesome/fontawesome-svg-core'
/* import font awesome icon component */
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
//版本
import { useVersionStore } from '@/store/versionStore'
// 匯入 Bootstrap 的 CSS
import { createHead } from '@vueuse/head'

// 2) 引入你需要使用的 icon
import {
    faAngleUp,
    faAngleDown,
    faTrash,
    faUser,
    faShoppingCart,
    faUsers,
    faBoxes,
    faBell,
    faFileCode,
    faImages,
    faBook,
    faCogs,
    faCreditCard,
    faStore,
    faCalendarCheck,
    faScissors,
    faTag,
    faBullhorn,
    faGauge,
    faHandshake,
    faMoneyBillWave
} from '@fortawesome/free-solid-svg-icons';

import { faCcMastercard, faCcVisa } from '@fortawesome/free-brands-svg-icons'


async function bootstrap() {


    library.add(
        faAngleUp,
        faAngleDown,
        faTrash,
        faUser,
        faShoppingCart,
        faUsers,
        faBoxes,
        faBell,
        faFileCode,
        faImages,
        faBook,
        faCogs,
        faCreditCard,
        faStore,
        faCalendarCheck,
        faScissors,
        faTag,
        faBullhorn,
        faGauge,
        faHandshake,
        faMoneyBillWave,
        faCcMastercard,
        faCcVisa
    );

    const app = createApp(App);


    const head = createHead()
    app.use(head)

    app.use(ElementPlus, {
        locale: zhTw
    })

    const pinia = createPinia()
    app.use(pinia)


    // 3. 現在才能透過 `useVersionStore()` 拿到「真正的 store 實例」
    const versionStore = useVersionStore()
    // 4. 呼叫 action
    await versionStore.checkServerVersion()
    // 2. 呼叫 versionStore.getSettings() 拿到設定（可能是物件或字串）
    const settings = await versionStore.getSettings()
    const posterTitles = await versionStore.getPosterTitles();

    // 5. 取得 settings
    app.config.globalProperties.$Settings = settings

    app.config.globalProperties.$PosterTitles = posterTitles

    app.config.globalProperties.$COMPANY_NAME = settings.COMPANY_NAME;
    app.config.globalProperties.$COMPANY_NAMEn = settings.COMPANY_NAMEN;
    app.config.globalProperties.$COMPANY_TAXID = settings.COMPANY_TAXID;
    

    console.log(settings)

    // 可在這裡傳入一些全域設定，例如 loading/error 圖
    app.use(VueLazyload, {
        observerOptions: {
            rootMargin: '0px',
            threshold: 0.1
        }
    })

    router.beforeEach((to, from, next) => {
       // document.title = to.meta.title || settings.COMPANY_NAMEN + ' | 自然與科技結合的極致護膚';
       // const defaultTitle = settings.COMPANY_NAMEN + ' | ' + "自然與科技結合的極致護膚";
        if (to.meta?.title) {
            // 你自己看是要把「|」寫在 meta 內，還是這裡寫
            document.title = to.meta.title;
        } else {
            document.title = settings.COMPANY_NAME;
        }
        next();
    });

    app.directive('intersect', {
        mounted(el, binding) {
            const options = {
                threshold: 0.1 // 触发回调的阈值
            };
            const observer = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        binding.value(entry); // 调用绑定的方法
                    }
                });
            }, options);
            observer.observe(el);
        }
    });

    /* 讓 <font-awesome-icon icon="trash" /> 生效 */
    app.component('font-awesome-icon', FontAwesomeIcon)
    app.use(router);
    app.use(store);
    app.mount('#app');

}

// 執行 bootstrap
bootstrap()
